/**
 * Key for the Rankers namespace on the global window object eg `window.Rankers_NS`.
 * Ideally *all* Rankers code should be namespaced under this key.
 * @type {string}
 */
export const RankersNamespaceKey = 'Rankers_NS';

export function ensureRankersNamespace() {
    if (!window[RankersNamespaceKey]) window[RankersNamespaceKey] = {};
}

ensureRankersNamespace();

export function getRankersNamespace() {
    ensureRankersNamespace();
    return window[RankersNamespaceKey];
}